import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = { class: "form-check form-switch" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_7 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_8 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_9 = {
  key: 2,
  class: "d-flex text-center bg-light rounded p-2 mb-2 small"
}
const _hoisted_10 = { class: "flex-fill" }
const _hoisted_11 = {
  key: 0,
  class: "lh-1 mb-1"
}
const _hoisted_12 = {
  key: 0,
  class: "badge bg-danger-subtle text-danger-emphasis",
  style: {"font-size":"0.6rem"}
}
const _hoisted_13 = {
  key: 1,
  class: "badge bg-success-subtle text-success-emphasis",
  style: {"font-size":"0.6rem"}
}
const _hoisted_14 = { class: "fs-5 fw-bold" }
const _hoisted_15 = { class: "flex-fill border-start" }
const _hoisted_16 = {
  key: 0,
  class: "lh-1 mb-1"
}
const _hoisted_17 = {
  key: 0,
  class: "badge bg-danger-subtle text-danger-emphasis",
  style: {"font-size":"0.6rem"}
}
const _hoisted_18 = {
  key: 1,
  class: "badge bg-success-subtle text-success-emphasis",
  style: {"font-size":"0.6rem"}
}
const _hoisted_19 = { class: "fs-5 fw-bold" }
const _hoisted_20 = { class: "d-flex flex-wrap align-items-end justify-content-between gap-3 mb-2" }
const _hoisted_21 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "form-check form-switch pt-1" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "mb-2" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "d-flex justify-content-center" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "alert alert-secondary py-2 mb-2 small" }
const _hoisted_32 = { class: "row g-0" }
const _hoisted_33 = { class: "col-6 ps-2" }
const _hoisted_34 = { class: "row g-0" }
const _hoisted_35 = { class: "col-6 ps-2" }
const _hoisted_36 = { class: "text-success" }
const _hoisted_37 = { class: "row g-0" }
const _hoisted_38 = { class: "col-6 ps-2" }
const _hoisted_39 = { class: "row g-0" }
const _hoisted_40 = { class: "col-6 ps-2" }
const _hoisted_41 = { class: "row g-0" }
const _hoisted_42 = { class: "col-6 ps-2" }
const _hoisted_43 = { class: "d-flex justify-content-between" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_47 = {
  key: 3,
  class: "alert alert-success py-2 mt-2 mb-0 small"
}
const _hoisted_48 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-share-alt fa-fw fa-rotate-90 me-1" }),
        _createTextVNode("Agregar Puntos de Binario ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input secondary",
            type: "checkbox",
            role: "switch",
            id: "enable-adjust-points",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.enabled]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.username)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.loadingBalances)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin me-1" }, null, -1),
                  _createTextVNode("Cargando… ", -1)
                ]))]))
              : (_ctx.balances && !_ctx.balances.placed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No colocado en binario. "))
                : (_ctx.balances)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", {
                          class: "text-muted text-uppercase",
                          style: {"font-size":"0.7rem"}
                        }, " Izquierda ", -1)),
                        (_ctx.legRole('left'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_ctx.legRole('left') === 'interna')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "interna"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_13, "derrame"))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.balances.left.pending.toLocaleString()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", {
                          class: "text-muted text-uppercase",
                          style: {"font-size":"0.7rem"}
                        }, " Derecha ", -1)),
                        (_ctx.legRole('right'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              (_ctx.legRole('right') === 'interna')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "interna"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_18, "derrame"))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.balances.right.pending.toLocaleString()), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.armed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small mb-1 d-block" }, "Lado", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    id: "side-left",
                    value: "left",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.side) = $event)),
                    disabled: !_ctx.enabled
                  }, null, 8, _hoisted_22), [
                    [_vModelRadio, _ctx.side]
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    class: "btn btn-outline-secondary",
                    for: "side-left"
                  }, " Izquierda ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    id: "side-right",
                    value: "right",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.side) = $event)),
                    disabled: !_ctx.enabled
                  }, null, 8, _hoisted_23), [
                    [_vModelRadio, _ctx.side]
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    class: "btn btn-outline-secondary",
                    for: "side-right"
                  }, " Derecha ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small mb-1 d-block" }, "Propagar", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "propagate-up",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.propagate) = $event)),
                    disabled: !_ctx.enabled
                  }, null, 8, _hoisted_25), [
                    [_vModelCheckbox, _ctx.propagate]
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    class: "form-check-label small",
                    for: "propagate-up"
                  }, [
                    _createElementVNode("i", { class: "fa-solid fa-arrow-up fa-fw me-1" }),
                    _createTextVNode("Hacia arriba ")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[18] || (_cache[18] = _createElementVNode("label", {
                  class: "form-label small mb-1 d-block",
                  for: "adjust-amount"
                }, " Cantidad ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "adjust-amount",
                  type: "number",
                  min: "1",
                  step: "1",
                  class: "form-control form-control-sm",
                  style: {"width":"7rem"},
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.amount) = $event)),
                  disabled: !_ctx.enabled
                }, null, 8, _hoisted_26), [
                  [
                    _vModelText,
                    _ctx.amount,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "form-label small mb-1",
                for: "adjust-reason"
              }, [
                _createTextVNode(" Motivo "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "adjust-reason",
                class: "form-control form-control-sm",
                rows: "2",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reason) = $event)),
                disabled: !_ctx.enabled
              }, null, 8, _hoisted_28), [
                [
                  _vModelText,
                  _ctx.reason,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary btn-sm",
                disabled: !_ctx.canReview,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.review()))
              }, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("i", { class: "fas fa-eye fa-fw me-1" }, null, -1),
                _createTextVNode("Revisar ", -1)
              ]))], 8, _hoisted_30)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-6 text-end text-muted" }, "Usuario:", -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.username), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-6 text-end text-muted" }, "Puntos:", -1)),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("strong", _hoisted_36, "+" + _toDisplayString(_ctx.amount?.toLocaleString()), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-6 text-end text-muted" }, "Lado:", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.side === "left" ? "Izquierda" : "Derecha"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-6 text-end text-muted" }, "Propagar:", -1)),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.propagate ? "Sí" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-6 text-end text-muted" }, "Motivo:", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("em", null, _toDisplayString(_ctx.reason), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary btn-sm",
                disabled: _ctx.adjusting,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel()))
              }, " Cancelar ", 8, _hoisted_44),
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                disabled: _ctx.adjusting,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submit()))
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-check fa-fw me-1" }, null, -1)),
                _cache[27] || (_cache[27] = _createTextVNode("Confirmar ", -1)),
                (_ctx.adjusting)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_45)
            ])
          ], 64)),
      (_ctx.resultReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _cache[29] || (_cache[29] = _createTextVNode(" Quitado ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.resultReport.removed), 1),
            _createTextVNode(" pts / " + _toDisplayString(_ctx.resultReport.nodesRemoved) + " nodos", 1),
            (_ctx.resultReport.notRecoverable > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                  _cache[28] || (_cache[28] = _createTextVNode(" · no recuperable ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.resultReport.notRecoverable), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[30] || (_cache[30] = _createTextVNode(". ", -1))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}